module.exports = __webpack_public_path__ + "img/entrepreneurship_ico.1990d306.png";